<template>
  <div v-if="majors.length">
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Chuyên ngành"
          :link="[{ text: 'Chuyên ngành', href: $route.path }]"
        />
      </div>
      <div>
        <major-parent-new-dialog v-if="['super_admin', 'education_manager'].includes(role.type)" />
      </div>
    </div>

    <v-card flat class="mx-md-2 mb-4" v-for="root in majors" :key="root.id">
      <v-card-text>
        <v-card-title>
          <span style="font-size: 20px; color: #212121">
            {{ root.title }}
          </span>
          <v-spacer />
          <major-new-dialog
            v-if="['super_admin', 'education_manager'].includes(role.type)"
            :root="root"
          />
        </v-card-title>

        <v-row no-gutters>
          <v-col :sm="12" :md="4" v-for="major in root.majors" :key="major.id">
            <card-major :major="major"></card-major>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MajorNewDialog from '@/modules/major/MajorNewDialog.vue'
import MajorParentNewDialog from '@/modules/major/MajorParentNewDialog.vue'
import CardMajor from '@/components/basic/card/MajorCard.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'

export default {
  components: {
    MajorNewDialog,
    CardMajor,
    MajorParentNewDialog,
    Breadcrumbs
  },
  async created() {
    await this.fetchMajors({ department: this.department.id, type: 'root' })
  },
  data: () => ({
    show: false
  }),
  computed: {
    ...mapGetters('major', ['majors', 'count', 'major']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('major', ['fetchMajors'])
  }
}
</script>
